/**
* Inspire-hub 2 (www.giap.pl)
*
* Copyright © GIAP sp.z.o.o. All rights reserved.
*
* Unauthorized copying of this file, via any medium is strictly prohibited
* Proprietary and confidential
* Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
*/

/* eslint-disable max-len */

import React, { PropTypes } from 'react';
import Stepper, { Step } from '../components/Stepper';
import StepClass from '../classes/StepClass';

const stepperWrapper = (comp, steps) => {
  // Validate second argument
  if (!Array.isArray(steps)) {
    const errString = `Steps should be an array type not ${typeof (steps)}`;
    console.debug(errString);
    throw new Error(errString);
  }
  // Validate second argument elements
  for (let step of steps) {
    if (!(step instanceof StepClass)) {
      const errString = `Each step should be an instance of StepClass not ${typeof (steps)}`;
      console.debug(errString);
      throw new Error(errString);
    }
  }
  const stepper = (
    <Stepper>
      {steps.map((v, i) => v.getStep(i, steps.reduce((prev, curr, index) => index <= i ? prev + curr.getUrl() : prev, '')))}
    </Stepper>);

  return (
    <div>
      {stepper}
      {comp}
    </div>
  );
};

export default stepperWrapper;



// WEBPACK FOOTER //
// src/hocs/stepperWrapper.js